import React from 'react';
import { FormGroup, FormControl, Grid, Row, Col, Button } from 'react-bootstrap';

import Api from '../../../api/api';
import { getURLParameter } from '../../../utils/helpers';
import ResubscribeModal from './ResubscribeModal';
import type { UserType } from '../../../utils/types';

class ExerciseReview extends React.Component {
  state = {
    exercises: [],
    showModal: false,
  };

  componentDidMount() {
    this.checkPaymentStatusAndFetchExercises();
  }

  checkPaymentStatusAndFetchExercises = (): void =>
    Api.users
      .getUserPersonalData()
      .then((user: UserType) => {
        if (user.payment_status === 'error') {
          this.props.history.push('/profile');
        } else {
          this.fetchCurrentWeekExercises();
        }
      })
      .catch(error => error.response.status === 401 && this.props.history.push('/login'));

  fetchCurrentWeekExercises() {
    const search = this.props.location.search;
    const week = search && search.slice(6);

    Api.users
      .getCurrentWeekExercises(week, 'exercises')
      .then(week_plan => {
        if (!week_plan.exercises.length) {
          this.props.history.push('/invalid-link');
        }

        this.setState({ exercises: week_plan.exercises });

        week_plan.exercises.forEach(exercise => this.getExerciseReview(exercise.number));
      })
      .catch(error => {
        if (error.response.status === 403) {
          this.setState({ showModal: true });
        }

        if (error.response.status === 404) {
          this.props.history.push('/invalid-link');
        }
      });
  }

  getExerciseReview = exerciseId =>
    Api.users.getExerciseReview(exerciseId).then(review => {
      const exercises = this.state.exercises.slice();
      const exercise = exercises.find(exercise => exercise.number === exerciseId);

      exercise.review = {
        value: review.value,
        message: review.message,
        allow_repeat: review.allow_repeat,
      };

      this.setState({ exercises });
    });

  handleValueChange = (number, prop, value) => {
    const exercises = this.state.exercises.slice();
    const exercise = exercises.find(exercise => exercise.number === number);
    exercise.review[prop] = value;

    this.setState({ exercises });
  };

  handleSubmit = () => {
    const reviews = this.state.exercises
      .map(
        exercise =>
          exercise.review.value && {
            number: exercise.number,
            review: { value: exercise.review.value, message: exercise.review.message },
          },
      )
      .filter(Boolean);

    if (reviews.length > 0) {
      const week = getURLParameter('week');

      return Api.users.reviewExercises(week, reviews).then(() => this.props.history.push('/profile'));
    }
  };

  handleResubscribe = () =>
    Api.users.subscribe().then(() => {
      this.handleModalClose();
      this.fetchCurrentWeekExercises();
    });

  handleModalClose = () => this.setState({ showModal: false });

  render() {
    const exercises = this.state.exercises;
    const disabled = exercises.some(exercise => exercise.review && !exercise.review.value);

    return (
      <Grid fluid className="">
        <div className="fullheight" style={{ paddingTop: 60 }}>
          <Row className="show-grid">
            <Col md={2} />
            <Col md={8}>
              <div className="modal-header">
                <h2 className="heading review-exercises">Please review the exercises you practiced this week</h2>
              </div>
            </Col>
            <Col md={2} />
          </Row>
          <Row className="review-main-row">
            <div>
              {exercises.length &&
                exercises.map((exercise, id) => (
                  <div className="review-practiced" key={`exercise-${id}`}>
                    <Row className="review-first-row">
                      <Col md={7} className="folklore-main">
                        <div className="folklore">
                          <span>{exercise.category.title}</span>
                        </div>
                        <div className="review-rosemary">
                          <span>{exercise.title}</span>
                        </div>
                      </Col>
                      <Col md={5}>
                        <div className="text-review-button">
                          <span>Keep this exercise in your plan?</span>
                        </div>
                        <div className="review-button">
                          <Button
                            className={`yes-button ${
                              exercise.review && exercise.review.value === 1 ? 'review-btn-active' : 'default'
                            }`}
                            onClick={() => this.handleValueChange(exercise.number, 'value', 1)}
                          >
                            Yes
                          </Button>
                          <Button
                            className={`no-button ${
                              exercise.review && exercise.review.value === 2 ? 'review-btn-active' : 'default'
                            }`}
                            onClick={() => this.handleValueChange(exercise.number, 'value', 2)}
                          >
                            No
                          </Button>
                          <Button
                            className={`undecided-button ${
                              exercise.review && exercise.review.value === 3 ? 'review-btn-active' : 'default'
                            }`}
                            onClick={() => this.handleValueChange(exercise.number, 'value', 3)}
                          >
                            Undecided
                          </Button>
                          {exercise.review && exercise.review.allow_repeat ? (
                            <a
                              className={`repeat-button ${
                                exercise.review && exercise.review.value === 4 ? 'review-btn-active' : 'default'
                              }`}
                              onClick={() => this.handleValueChange(exercise.number, 'value', 4)}
                            >
                              Repeat<span className="repeat-info">
                                <span className="repeat-info-in">
                                  Select Repeat if you wish this exercise to be included in the next exercise offer.
                                </span>
                              </span>
                            </a>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <Row className="review-second-row">
                      <Col md={12}>
                        <div>
                          <FormGroup>
                            <FormControl
                              componentClass="textarea"
                              value={exercise.review ? exercise.review.message : ''}
                              onChange={e => this.handleValueChange(exercise.number, 'message', e.target.value)}
                              placeholder="Feedback and advice"
                            />
                          </FormGroup>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))}
              <div className="white-submit">
                <Button type="submit" disabled={disabled} onClick={this.handleSubmit}>
                  Submit
                </Button>
              </div>
            </div>
          </Row>
          <ResubscribeModal show={this.state.showModal} handleResubscribe={this.handleResubscribe} />
        </div>
      </Grid>
    );
  }
}

export default ExerciseReview;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Exercises/ExerciseReview.js